import React, { useCallback } from 'react';

import { SearchCategory } from 'api/home/types';
import { useOTSTranslation } from 'i18n/useOTSTranslation';
import { labelMap } from 'components/home/SearchPopup';

import styles from './styles.module.scss';

interface ISearchResultsPopUpProps {
  label: string
  data: Array<any>
  dataKey: string
  onSelect: (item: any) => void
}

const SearchResultsPopUp = ({
  label, data, dataKey, onSelect,
}: ISearchResultsPopUpProps) => {
  const { t } = useOTSTranslation('common');
  const columnLabel = t(labelMap[label as SearchCategory]);

  const onClick = useCallback((e: React.SyntheticEvent) => {
    const element = e.target as HTMLLIElement;
    const { id } = element.dataset;
    if (id) {
      onSelect(data[+id]);
    }
  }, [onSelect, data]);

  return (
    <div className={styles.popUp}>
      <div className={styles.container}>
        <header>{columnLabel}</header>
        {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
        <ul
          onClick={onClick}
          className={styles.resultsList}
        >
          {data.map((i: any, index) => (
            <li
              key={i[dataKey]}
              data-id={index}
            >
              {i[dataKey]}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default SearchResultsPopUp;
